// Keep Quick Buy usable for cards rendered at load and cards inserted by filters.
// The compiled bundle binds clicks directly to initial cards; this capture
// handler owns the toggle so the two handlers cannot open/close the same panel.
(() => {
  const initializedPanels = new WeakSet();

  function getTrigger(panel) {
    return panel.parentNode && panel.parentNode.querySelector('.quick-buy-button');
  }

  function syncPanelVisibility(panel) {
    const open = panel.classList.contains('translate-y-0');
    panel.hidden = !open;
    panel.style.display = open ? '' : 'none';
    const trigger = getTrigger(panel);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function setPanelOpen(panel, open, returnFocus = false) {
    panel.classList.toggle('translate-y-full', !open);
    panel.classList.toggle('translate-y-0', open);
    syncPanelVisibility(panel);

    if (open) {
      document.dispatchEvent(new CustomEvent('quick-buy:opened', { detail: { panel } }));
      const firstControl = panel.querySelector('select, .close-button, [type="submit"]');
      if (firstControl) firstControl.focus();
    } else if (returnFocus) {
      const trigger = getTrigger(panel);
      if (trigger) trigger.focus();
    }
  }

  function initializePanels(root) {
    const panels = root.matches && root.matches('form-quick-buy')
      ? [root]
      : root.querySelectorAll('form-quick-buy');

    panels.forEach((panel) => {
      if (initializedPanels.has(panel)) return;
      initializedPanels.add(panel);
      syncPanelVisibility(panel);
      // The compiled cart handler may close the panel after an add. Reflect
      // its class change without taking focus from the cart drawer.
      new MutationObserver(() => syncPanelVisibility(panel)).observe(panel, {
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const closeButton = event.target.closest('form-quick-buy .close-button');
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      setPanelOpen(closeButton.closest('form-quick-buy'), false, true);
      return;
    }

    const trigger = event.target.closest('.quick-buy-button');
    if (!trigger) return;
    const panel = trigger.parentNode && trigger.parentNode.querySelector('form-quick-buy');
    if (!panel) return;

    event.preventDefault();
    event.stopPropagation();
    const shouldOpen = !panel.classList.contains('translate-y-0');
    document.querySelectorAll('form-quick-buy.translate-y-0').forEach((openPanel) => {
      if (openPanel !== panel) setPanelOpen(openPanel, false);
    });
    setPanelOpen(panel, shouldOpen, !shouldOpen);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = event.target instanceof Element && event.target.closest('form-quick-buy.translate-y-0');
    if (!panel || panel.closest('[inert]')) return;
    event.preventDefault();
    setPanelOpen(panel, false, true);
  });

  function start() {
    initializePanels(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) initializePanels(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
